import {CloseCircleFilled, PlusCircleOutlined} from '@ant-design/icons';
import {Button, Empty, Form} from 'antd';
import cn from 'classnames';
import React, {useState} from 'react';

import {CustomSelect} from 'components/form/inputs/custom-select';
import {IDefaultModalOpenerFormListProps} from 'components/report-configuration/report-configuration.types';
import {IconFormatFormItem} from 'components/report-configuration/tabs/report-table-settings/modals/icon-format-settings-modal-opener/icon-format-settings-modal-content/icon-format-form-item';
import {ReactComponent as TrashX} from 'shared/assets/trash-x.svg';
import {useAppSelector} from 'store/config/hooks';
import './icon-format-settings-modal-content.less';
import {selectReportConfigurationTableAttributesAsSelectEntries} from 'store/slices/report-configuration-slice/report-configuration-slice';

export const IconFormatSettingsModalContent = ({
    form,
    name,
}: IDefaultModalOpenerFormListProps) => {
    const tableAttributesEntries = useAppSelector(selectReportConfigurationTableAttributesAsSelectEntries);

    const [selectedRows, setSelectedRows] = useState<number[]>([]);

    return (
        <div className={cn('icon-format-modal-content')}>
            <div>
                <Form.Item
                    rules={[{required: true}]}
                    label="Размещение"
                    style={{width: 240}}
                    name={[name, 'align']}
                >
                    <CustomSelect
                        settings={{
                            url: 'lookupValue/TABLE_REPORT_CELL_ALIGN',
                            valuePath: 'lookupCode',
                            labelPath: 'meaning',
                            placeholder: 'Выберите вариант',
                            isClearable: true,
                        }}
                    />
                </Form.Item>
            </div>
            <Form.List name={[name, 'cases']}>
                {(fields, operations) => (
                    <div>
                        <div className={cn('icon-format-modal-content__buttons')}>
                            <Button
                                disabled={!tableAttributesEntries?.length}
                                type="primary"
                                onClick={() => operations.add()}
                            >
                                <PlusCircleOutlined />
                                Добавить
                            </Button>
                            <Button
                                disabled={!selectedRows.length}
                                type="primary"
                                onClick={() => {
                                    operations.remove(selectedRows);
                                    setSelectedRows([]);
                                }}
                            >
                                <TrashX />
                                Удалить выбранное
                            </Button>
                            <Button
                                disabled={!fields.length}
                                type="primary"
                                onClick={() => {
                                    operations.remove(fields.map(f => f.name));
                                }}
                            >
                                <CloseCircleFilled />
                                Удалить все
                            </Button>
                        </div>

                        {(() => {
                            if (!fields.length) {
                                return <Empty description="Данные отсутствуют" />;
                            }
                            return null;
                        })()}

                        {fields.map(field => (
                            <IconFormatFormItem
                                key={field.name}
                                form={form}
                                name={name}
                                fields={fields}
                                field={field}
                                selectedRows={selectedRows}
                                setSelectedRows={setSelectedRows}
                            />
                        ))}
                    </div>
                )}
            </Form.List>
        </div>
    );
};
